import { request } from "../utils/request"


export function _getExamInfo(data) {
    return request({
        url: 'stuwebapi/study.exam/getExamInfo',
        method: 'post',
        data,
        isLoading: data.load,
        isShowMsg: data.isShowMsg,
        isShowErr: data.isShowErr
    })
}

export function _getExamQues(data) {
    return request({
        url: 'stuwebapi/study.exam/getExamQues',
        method: 'post',
        data,
        isLoading: data.load,
        isShowMsg: data.isShowMsg,
        isShowErr: data.isShowErr
    })
}

export function _enterExam(data) {
    return request({
        url: 'stuwebapi/study.exam/enterExam',
        method: 'post',
        data,
        isLoading: data.load,
        isShowMsg: data.isShowMsg,
        isShowErr: data.isShowErr
    })
}
